export default __webpack_public_path__ + "static/media/gradient-shadow-bottom.6c1f181b.svg";